import React from 'react';
import { Menu, MenuItems } from '@headlessui/react';
import { Badge } from 'components/badges';
import StackedListMenuItem from 'components/stackedLists/StackedListMenuItem/StackedListMenuItem';
import StackedListMenuToggle from 'components/stackedLists/StackedListMenuToggle/StackedListMenuToggle';
import { formatDateToLocal, getDateTimePatterns } from 'utils/date';
import {
  NOTIFICATION_TYPE_BADGE_CLASSNAMES,
} from 'constants/notifications';
import {
  getNotificationTarget,
  getNotificationTypeLabel,
} from 'utils/notifications';
import NotificationChannelIndicator from '../../../../components/notifications/NotificationChannelIndicator/NotificationChannelIndicator';

export default function NotificationListItem({ item, settings, onAction, isUpdating = false }) {
  const { dateTimePattern } = getDateTimePatterns(settings);
  const createdDate = formatDateToLocal(item.createdAt, dateTimePattern);
  const target = getNotificationTarget(item);

  const handleAction = (action) => {
    onAction?.(action, item);
  };

  return (
    <li className="flex justify-between gap-x-6 px-4 py-5 transition-colors hover:bg-gray-800/50">
      <button
        type="button"
        onClick={() => handleAction('read')}
        disabled={isUpdating}
        className="min-w-0 flex-1 text-left cursor-pointer disabled:cursor-not-allowed"
      >
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            {!item.isRead && (
              <span
                aria-hidden="true"
                className="size-2 shrink-0 rounded-full bg-indigo-400"
              />
            )}
            <p className="truncate text-sm font-semibold leading-6 text-white">
              {item.title || getNotificationTypeLabel(item.type)}
            </p>
            <NotificationChannelIndicator channel={item.channel} className="shrink-0" />
            <Badge size="sm" className={NOTIFICATION_TYPE_BADGE_CLASSNAMES[item.type]}>
              {getNotificationTypeLabel(item.type)}
            </Badge>
          </div>

          <p className="mt-2 text-sm leading-6 text-gray-400">
            {item.content || 'No message content.'}
          </p>

          <div className="mt-2 text-xs text-gray-500">
            <time dateTime={item.createdAt}>{createdDate}</time>
          </div>
        </div>
      </button>

      <div className="flex shrink-0 items-center gap-x-4">
        <Menu as="div" className="relative flex-none">
          <StackedListMenuToggle />
          <MenuItems
            transition
            anchor="bottom end"
            className="w-44 origin-top-right rounded-md bg-gray-800 py-2 shadow-lg ring-1 ring-white/10 focus:outline-none transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
          >
            <StackedListMenuItem onClick={() => handleAction('open')} disabled={isUpdating}>
              {target.label}
            </StackedListMenuItem>
            {!item.isRead ? (
              <StackedListMenuItem onClick={() => handleAction('mark-read')} disabled={isUpdating}>
                Mark as read
              </StackedListMenuItem>
            ) : (
              <StackedListMenuItem onClick={() => handleAction('mark-unread')} disabled={isUpdating}>
                Mark as unread
              </StackedListMenuItem>
            )}
            <StackedListMenuItem variant="danger" onClick={() => handleAction('delete')} disabled={isUpdating}>
              Delete
            </StackedListMenuItem>
          </MenuItems>
        </Menu>
      </div>
    </li>
  );
}
